import React ,{useState, useEffect} from 'react';
import { useNavigate } from 'react-router';
import YouTube from "react-youtube";
import { 
        EuiFlexGroup,
        EuiFlexItem,
        EuiSpacer,
        EuiButton,
        EuiTitle,
        EuiText,
        EuiModal,
        EuiModalHeader,
        EuiModalBody,
        EuiModalHeaderTitle,
        EuiModalFooter,
        EuiHorizontalRule,
        euiDragDropReorder,
        EuiAccordion,
        EuiPanel,
        copyToClipboard,
        EuiHeader,
        EuiHeaderSection,
        EuiHeaderSectionItem,
        EuiListGroup,
        EuiButtonEmpty} from '@elastic/eui';
import {TranslateLanguage} from '../components/KeywordTranslator';   
import Footer from '../components/Footer';    
import { keepScreenAwakeForPlayback, releaseScreenAwakeForPlayback } from './nativePlaybackBridge';

import '../style.css';
import logosmall from '../assets/CTBLogoCircle-Small.png';
import LoadUserSettings, {RemovePlayListItem, SaveUserSettings, ExtractItemFromURL} from '../components/UserServices';
import TopRightMenu from "../components/TopRightMenu"; 
import LanguageToggle from "../components/LanguageToggle";

const apiURL = process.env.REACT_APP_MasterApiURL;
const apiKey = process.env.REACT_APP_APIKey;

// var videoJson = '[{"id": "i2", "playListId": "1", "title": "活出愛", "itemId": "lfP-3JLVvaw","itemType" : "v", "docType" : "詩歌" }]'
var videoJson = '[{"id": "ctb-worship-tc|3101", "playListId": "1", "title": "活出愛", "videoId": "lfP-3JLVvaw","itemType" : "v", "docType" : "詩歌" }]'
var videoIdList =  (LoadUserSettings("","shareItemList", true)) ? LoadUserSettings("","shareItemList", true) : JSON.parse(videoJson);

// var videoIdList =  JSON.parse(videoJson);

function Share(props) {
  const navigate = useNavigate();
  const [videoId, setVideoId] = useState("loJ8jTRfCik");
  const [currentVideoId, setCurrentVideoId] = useState(0);
  const [closePanelWhenPlay, setClosePanelWhenPlay] = useState(false);
  const [loopPlay, setLoopPlay] = useState(false);
  const [isModalVisible, setisModalVisible] = useState(false);
  const [list, setList] = useState(videoIdList);
  const [listText, setListText] = useState("");
  const [isLoaded, setIsLoaded] = useState(false);
  const [shareLink, setSharelink] = useState("");
  const [shareText, setShareText] = useState("");
  const [hideLyric, sethideLyric] = useState(1);

  const currentURL = window.location.origin;
  const language = localStorage.userLanguage;
  const urlParams = new URLSearchParams(window.location.search);

  // ---- Base64 URL-safe 編碼/解碼（可處理 Unicode） ----
  const toBase64Url = (str) => {
    const bytes = new TextEncoder().encode(str);
    let bin = "";
    bytes.forEach(b => (bin += String.fromCharCode(b)));
    return btoa(bin).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
  };

  const fromBase64Url = (b64url) => {
    let b64 = b64url.replace(/-/g, "+").replace(/_/g, "/");
    while (b64.length % 4) b64 += "=";             // 自動補 padding
    const bin = atob(b64);
    const bytes = Uint8Array.from(bin, c => c.charCodeAt(0));
    return new TextDecoder().decode(bytes);
  };

  // ---- 安全解碼 items（依序嘗試：URL-safe Base64 → 標準 Base64 → URL decode → 原字串）----
  const safeDecodeItems = (raw) => {
    if (!raw) return "";
    try { return fromBase64Url(raw); } catch {}
    try {
      const bin = atob(raw);
      const bytes = Uint8Array.from(bin, c => c.charCodeAt(0));
      return new TextDecoder().decode(bytes);
    } catch {}
    try { return decodeURIComponent(raw); } catch {}
    return raw; // 仍可用作逗號分隔的明文
  };

  const getList = async () =>{
    if(urlParams.has('items')){
      // var itemList = urlParams.get('items');
      // var matchItemList = atob(itemList).split(',');
      const itemList = urlParams.get('items');
      const decodedCsv = safeDecodeItems(itemList);      // ✅ 永不丟例外
      const matchItemList = decodedCsv.split(',')
        .map(s => s.trim())
        .filter(Boolean);
      if (matchItemList.length === 0) {                  // 沒有有效項目就結束
        setList([]); setListText([]); setIsLoaded(true);
        return;
      }
      var filterList =[];
          matchItemList.forEach((element, index) => {
          filterList.push(element)
        });
      await fetch(apiURL,{
              method:"POST",
              headers:{
                  "Content-Type":"application/json, charset=UTF-8",
                  "Authorization":  "Bearer search-" + apiKey
              },
              body:JSON.stringify({
                  query:"",
                  filters: {"any": {"id": filterList}  }, 
                  page:{size: 1000},
                  sort:{id: "asc"}
              })
          })
          .then(function(response){
              return(response.json())
          })
          .then(function(data){
              var results = JSON.parse(JSON.stringify(data));
              var extractedVideos = [];
              var extractedTexts = [];
              filterList.forEach((element, index) => {
                var foundItem = results.results.find(({id}) => id.raw === element)
                if(foundItem){
                    console.log("fournditem",foundItem);
                    var foundDocType = "t"
                    foundDocType = (foundItem.doctype.raw == "詩歌" || foundItem.doctype.raw == "信息" || foundItem.doctype.raw == "禱告")? "v" : foundDocType;
                    foundDocType = (foundItem.doctype.raw == "網路") ? (foundItem.category.raw == "見證" ) ? "v" :foundDocType :foundDocType;
                  if(foundDocType =="v"){
                    var videoId = foundItem.link.raw.match(/(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/)[1];
                    if(foundItem.doctype.raw != "禱告")
                    {
                      extractedVideos.push({
                        id: foundItem.id.raw,
                        playListId: "1",
                        videoId: videoId,
                        description: foundItem.description.raw,
                        title: foundItem.title.raw,
                        publisher: foundItem.publisher?.raw ?? "",
                        verselist: foundItem.verselist?.raw ?? "",
                        doctype: foundItem.doctype.raw
                      });
                    }
                    if(foundItem.doctype.raw == "禱告")
                    {
                      extractedVideos.push({
                        id: foundItem.id.raw,
                        playListId: "1",
                        videoId: videoId,
                        description: foundItem.prayer.raw,
                        title: foundItem.title.raw,
                        publisher: foundItem.publisher?.raw ?? "",
                        verselist: foundItem.verselist?.raw ?? "",
                        doctype: foundItem.doctype.raw
                      });
                    }
                  }
                  // If not video type, add record context (title + description ) to a state
                  if(foundDocType =="t"){
                    var title = (foundItem.doctype.raw != "經文") ?  foundItem.title.raw : 
                                foundItem.title.raw + " ( " + foundItem.chapter_name.raw + " " + foundItem.chapter_verse_number.raw +" )";
                    var description = (foundItem.description) && foundItem.description.raw ;
                    description = (foundItem.prayer) ? foundItem.prayer.raw : description;
                    var verseNumber = ( foundItem.chapter_verse_number) ? foundItem.chapter_verse_number.raw : "";
                    var chapterName = ( foundItem.chapter_name) ? foundItem.chapter_name.raw : "";
                    var verse = ( foundItem.verse) ? foundItem.verse.raw : "";
                    extractedTexts.push({
                      id: foundItem.id.raw,
                      playListId: "1",
                      description: description,
                      title: title,
                      chapterName: chapterName,
                      chapter_verse_number: verseNumber,
                      verse: verse,
                      doctype: foundItem.doctype.raw,
                      });
                  }
                }
              })
              setList(extractedVideos); 
              setListText(extractedTexts);
              loadVideo(currentVideoId);
          }
        )
    }
  }

  const opts = {
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
       autoplay: 1,
       playsinline: 1,
       rel: 0,
       modestbranding: 1,
       enablejsapi: 1
     //  mute: 1
    }
  };     
    useEffect(()=>{
        // list.length > 0 && loadVideo(currentVideoId);
       if(urlParams.has('items')){
            getList() 
            setIsLoaded(true);
       } else {
            document.location.href="/";
       } 
     },[])

    const loadVideo = (videoIndex) => {
        if(videoIndex < list.length && videoIndex >= 0){
            setCurrentVideoId(videoIndex)
         }
    }

    const onReady = (e) => {
      e.target.playVideo();
    }

    const onLoopPlay = (e) => {
      setLoopPlay(e.target.checked);
    }
 
    const checkStateChange = (e) => {
        if (e.target.playerInfo.playerState === 1) keepScreenAwakeForPlayback();
        if ([0, 2].includes(e.target.playerInfo.playerState)) releaseScreenAwakeForPlayback();
        if(e.target.playerInfo.playerState === 0){
            // auto next
            var nextId = currentVideoId + 1;
            if(loopPlay && nextId >= videoIdList.length ){
               nextId = 0;
            }
            loadVideo(nextId);
           
          }
      };

      const onDragEnd = ({ source, destination }) => {
        if (source && destination) {
          const items = euiDragDropReorder(list, source.index, destination.index);
          setList(items);
          // localStorage.shareItemList = JSON.stringify(items);
          SaveUserSettings("","shareItemList",items, true);
          window.location.reload();
        }
      };

      const onRemoveItem = (index) => {
        var newList = RemovePlayListItem("", 1, index);
        setList(newList);
        window.location.reload();
      }

      // const shareClicked = ()=> {
      //   var items = "";
      //   list.forEach((element, index) => {
      //     items += element.id + ",";
      //   })
      //   items = window.location.origin + "/player?items=" + btoa(items.substring(0,items.length-1));
      //   setSharelink(items);
      //   setisModalVisible(true);
      // }

      const shareClicked = () => {
         const csv = list.map(el => el.id).join(",");
         const encoded = toBase64Url(csv);                // ✅ URL-safe Base64
         const link = `${window.location.origin}/player?items=${encoded}`;
         setSharelink(link);
         setisModalVisible(true);
       };

      const closeModal =()=> {
        copyToClipboard(shareLink);
        setisModalVisible(false);
      }

      const onSearch = (e) => {
        navigate('/?q="' + e + '"' );
      }

      let modal;
      if (isModalVisible) {
        modal = (
          <EuiModal onClose={closeModal}>
            <EuiModalHeader>
              <EuiModalHeaderTitle>
                <h2> {TranslateLanguage(language, "分享我的歌單")}</h2>
              </EuiModalHeaderTitle>
            </EuiModalHeader>
    
            <EuiModalBody>
            {TranslateLanguage(language, "您可以使用以下的連結來分享您的歌單。")}
              <EuiSpacer />{shareLink}
            </EuiModalBody>
    
            <EuiModalFooter>
              <EuiButton onClick={closeModal} fill>
              {TranslateLanguage(language, "複製 Copy")}
              </EuiButton>
            </EuiModalFooter>
          </EuiModal>
        );
      }

    return (
      <>
      <div className="appHeaderSticky">
          <EuiHeader className="no-shadow-header">
              <EuiHeaderSection>
              {/* 左侧：Logo / 搜索等 */}
              </EuiHeaderSection>
              <EuiHeaderSection side="right">
              {/* 右侧：你的按钮 */}
              {/* 新增首页按钮 */}
              <EuiHeaderSectionItem>
                  <EuiButtonEmpty
                      size="s"
                      iconType="home"
                      onClick={() => navigate('/')}
                      color="text"
                      iconSide="left"
                      style={{
                      fontWeight: 500,
                      fontSize: '14px',
                      display: 'flex',
                      alignItems: 'center',
                      height: '32px',
                      padding: '0 8px',
                      }}
                  >
                  {TranslateLanguage(localStorage.userLanguage, "首頁")}
                  </EuiButtonEmpty>
              </EuiHeaderSectionItem>
              <EuiHeaderSectionItem>
                  <LanguageToggle />
              </EuiHeaderSectionItem>
              <EuiHeaderSectionItem>
                  <TopRightMenu withLanguage="1" />
              </EuiHeaderSectionItem>
              </EuiHeaderSection>
          </EuiHeader>
      </div>
      <div>
        <EuiFlexGroup responsive={false} alignItems="center">
              <EuiFlexItem></EuiFlexItem>
              <EuiFlexItem style={{ textAlign: 'center'}} grow={false}>
                 <span><a href={currentURL}><img  src={logosmall} alt="Check The Bible" /></a></span>
              </EuiFlexItem>
              <EuiFlexItem  grow={false}>
              <EuiTitle size="m"><h2 id="myworshipsongs">{TranslateLanguage(language, "好友分享")}</h2></EuiTitle>
              </EuiFlexItem>
              <EuiFlexItem></EuiFlexItem>
          </EuiFlexGroup>
        <EuiFlexGroup justifyContent="center">
        <EuiFlexItem grow={false} style={{ width: '100%' }}>
          {isLoaded && list.length > 0 ? (
            <div className="share-wrap">
              {/* 左：影片 */}
              <div className="video-col">
                <div className="video-box">
                  <YouTube
                    id="ytPlayer"
                    videoId={list[currentVideoId].videoId}
                    onStateChange={checkStateChange}
                    onReady={onReady}
                    // 不再依賴 className/containerClassName，直接靠 .video-box 的規則
                    opts={{ playerVars: { autoplay: 1, playsinline: 1, rel: 0, modestbranding: 1 } }}
                  />
                </div>
              </div>

        {/* 右：資訊欄 */}
        <aside className="sidePanel">
          {/* 播放清單 */}
          <EuiListGroup
            flush
            bordered
            maxWidth={false}
            listItems={list
              .filter(v => v.videoId)     // ✅ 只保留有 videoId 的項目
              .map((v, i) => ({
                label: TranslateLanguage(language, v.title),
                size: 's',
                isActive: i === currentVideoId,
                wrapText: true,
                onClick: () => setCurrentVideoId(i)
              }))
            }
          />
          <EuiHorizontalRule margin="m" />

          {/* 當前曲目資訊 */}
          {/* {list[currentVideoId] && (
            <EuiAccordion
              id={`meta-${list[currentVideoId].id}`}
              buttonContent={list[currentVideoId].title}
              initialIsOpen={false}
              arrowDisplay="right"
            >
              <EuiSpacer />
              <EuiText>{list[currentVideoId].description}</EuiText>
              <EuiSpacer />
              <EuiText>{list[currentVideoId].publisher}</EuiText>
              <EuiSpacer />
              <EuiText>{list[currentVideoId].verselist}</EuiText>
            </EuiAccordion>
          )} */}

          <EuiHorizontalRule />

          {/* 其他文字內容（經文/文字分享） */}
          {listText.length > 0 &&
            listText.map((element) => (
              <React.Fragment key={element.id}>
                {element.doctype !== '經文' ? (
                  <EuiAccordion
                    id={element.id}
                    buttonContent={TranslateLanguage(language, element.title)}
                    initialIsOpen
                    arrowDisplay="right"
                  >
                    <EuiPanel color="subdued">
                      <EuiText>{TranslateLanguage(language, element.description)}</EuiText>
                    </EuiPanel>
                  </EuiAccordion>
                ) : (
                  <EuiAccordion id={element.id} buttonContent={TranslateLanguage(language, element.title)} initialIsOpen={false} arrowDisplay="none">
                    <EuiPanel color="subdued">
                      <EuiButtonEmpty onClick={() => onSearch(element.verse)}>{TranslateLanguage(language, "搜尋經文")}</EuiButtonEmpty>
                    </EuiPanel>
                  </EuiAccordion>
                )}
                <EuiHorizontalRule />
              </React.Fragment>
            ))}
        </aside>
      </div>
    ) : (
      <div className="share-wrap">
        <div />
        <aside className="sidePanel" style={{ padding: 20 }}>
          {listText.length > 0 &&
            listText.map((element) => (
              <React.Fragment key={element.id}>
                <EuiAccordion
                  id={element.id}
                  buttonContent={TranslateLanguage(language, element.title)}
                  initialIsOpen={element.doctype !== "經文"}
                  arrowDisplay={element.doctype === "經文" ? "none" : "right"}
                >
                  <EuiPanel color="subdued">
                    <EuiButtonEmpty onClick={() => onSearch(element.verse)}>{TranslateLanguage(language, "搜尋經文")}</EuiButtonEmpty>
                  </EuiPanel>
                </EuiAccordion>
                <EuiHorizontalRule />
              </React.Fragment>
            ))}
        </aside>
      </div>
    )}
  </EuiFlexItem>
</EuiFlexGroup>

    </div>
    </>
  )
}

export default Share
